:host {
  display: block;

  a {
    display: block;
  }
}
